import { BaseInput, ProviderAccountRole, ProviderInvitation, SelectField, SimpleAccountObject } from '@enter/core';
import { Formik, FormikHelpers, FormikProps } from 'formik';
import _ from 'lodash';
import React, { useMemo } from 'react';
import * as Yup from 'yup';
import * as S from './invitation-role-modal.styles';

const schema = Yup.object().shape({
    roles: Yup.array().of(Yup.object().shape({})),
});

type FormProps = {
    roles: ProviderAccountRole[];
};

type InvitationRoleModalProps = {
    invitations: ProviderInvitation[];
    accounts: SimpleAccountObject[];
    roles: ProviderAccountRole[];
    onSubmit: (roles: ProviderAccountRole[]) => Promise<void>;
    onClose: () => void;
};

const getDisplayRoles = (role: string | undefined) => {
    if (!role) {
        return role;
    }

    const rolesMap = {
        ['PROVIDER_ADMIN_ACCESS']: 'Admin',
        ['PROVIDER_READ_ACCESS']: 'Read Only',
        ['PROVIDER_READ_WRITE_ACCESS']: 'Read and Write',
    };

    return rolesMap[role] || role;
};

export const InvitationRoleModal = ({ invitations, accounts, roles, onSubmit, onClose }: InvitationRoleModalProps) => {
    const handleSubmit = async (values: FormProps, formik: FormikHelpers<FormProps>) => {
        const newRoles = values.roles.filter(el => el.roleId !== undefined);
        formik.setSubmitting(true);

        try {
            await onSubmit(newRoles);
        } finally {
            formik.setSubmitting(false);
        }
    };

    const initialValues: FormProps = useMemo(() => {
        return {
            roles: accounts.map(account => {
                const accountRole = _.find(invitations, invitation => invitation.accountId === account.accountId);
                return {
                    accountId: account.accountId,
                    roleId: accountRole?.roleId,
                };
            }),
        };
    }, [invitations]);

    return (
        <S.Wrapper>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validationSchema={schema}
                validateOnChange={false}
                onSubmit={handleSubmit}>
                {(formik: FormikProps<FormProps>) => (
                    <S.SubCategoryItem>
                        <S.SubCategoryForm>
                            {accounts.map((account, i) => (
                                <S.SubCategoryRow key={account.accountId}>
                                    <S.SubCategoryCol>
                                        <S.InputGroup>
                                            <S.InputWrapper>
                                                <BaseInput value={account.name} disabled={true} />
                                            </S.InputWrapper>
                                        </S.InputGroup>
                                    </S.SubCategoryCol>
                                    <S.SubCategoryCol>
                                        <S.InputGroup>
                                            {/* <S.Label>Role</S.Label> */}
                                            <S.FormField
                                                name={`roles[${i}].roleId`}
                                                component={SelectField}
                                                options={roles.map(role => {
                                                    return {
                                                        value: role.roleId,
                                                        label: getDisplayRoles(role.roleId),
                                                    };
                                                })}
                                            />
                                        </S.InputGroup>
                                    </S.SubCategoryCol>
                                </S.SubCategoryRow>
                            ))}
                        </S.SubCategoryForm>
                        <S.ButtonGroup
                            changed={true}
                            useNotify={false}
                            onCancel={onClose}
                            onSave={formik.submitForm}
                            saveLabel="Save"
                        />
                    </S.SubCategoryItem>
                )}
            </Formik>
        </S.Wrapper>
    );
};
